import { Controller } from "@hotwired/stimulus"

// Keeps the transcript scrolled to the newest turn. Answers arrive
// asynchronously over Turbo Streams, so without this a reply can land below
// the fold and look like nothing happened.
//
// Only auto-scrolls when the reader is already at the bottom: if they scrolled
// up to re-read something, yanking the view away mid-read is worse than a
// missed message.
export default class extends Controller {
  static NEAR_BOTTOM_PX = 120

  connect() {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => {
      if (this.wasNearBottom) this.scrollToBottom()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.element.addEventListener("scroll", this.trackPosition)
    this.wasNearBottom = true
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener("scroll", this.trackPosition)
  }

  trackPosition = () => {
    const distance = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
    this.wasNearBottom = distance <= this.constructor.NEAR_BOTTOM_PX
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
